export default __webpack_public_path__ + "static/media/blob-bottom-origin.f24d3b0d.png";